package org.hs_soft.runmynesto.pages.home.sub_page.template.mvi

import kotlinx.coroutines.Job
import org.hs_soft.runmynesto.domain.model.home.closing_reports.CurrencyTypeEnum
import org.hs_soft.runmynesto.domain.model.home.product.products_list_model.ProductItem
import org.hs_soft.runmynesto.domain.model.home.template.GridItemsFilterEnum
import org.hs_soft.runmynesto.domain.model.home.template.TemplateInfoHeaderEnum
import org.hs_soft.runmynesto.domain.model.home.template.product_categories.TemplateCategoryModel
import org.hs_soft.runmynesto.domain.model.home.template.tabs.tab_general.ArticleSortEnum
import org.hs_soft.runmynesto.domain.model.home.template.tabs.tab_general.ListingLayoutsEnum
import org.hs_soft.runmynesto.domain.model.home.template.tabs.tab_general.WaiterDeviceTypeEnum
import org.hs_soft.runmynesto.domain.model.home.template.tabs.tab_general.calendar.MonthModel
import org.hs_soft.runmynesto.domain.model.home.template.tabs.tab_general.calendar.YearModel
import org.hs_soft.runmynesto.domain.model.home.template.tabs.tab_general.product_based_on_category.Item
import org.hs_soft.runmynesto.domain.model.home.template.tabs.tab_general.template_category_detail.GetCategory
import org.hs_soft.runmynesto.domain.model.home.user.tabs.user_checkout.user_checkout_model.Children
import org.hs_soft.runmynesto.domain.util.Constants
import org.hs_soft.runmynesto.domain.util.getYearsData

data class TemplateState(
    val selectedTab: TemplateInfoHeaderEnum =
        TemplateInfoHeaderEnum.GENERAL,
    val loadingProgress:Boolean=false,
    val templateCategoryListLoading:Boolean=false,
    val addNewCategoryLoading:Boolean=false,
    val errorInfo:String?=null,
    val templateItemImg:String ?= null,
    val searchedProductValue:String="",
    val companyProfileId:String="",
    val searchJob:Job ?= null,
    val searchedProducts:List<ProductItem> =  listOf(),
    val articleRowsCount:Int=1,
    val articleColumnsCount:Int=1,
    val isFoodPositionSortedAsc:Boolean=false,
    val isArticleTitleSortedAsc:Boolean=true,
    val showArticleTitleSortIcon:Boolean=false,

    val templateCategoryList:List<TemplateCategoryModel> = emptyList(),
    val selectedCategory: GetCategory?=null,
    val selectedArticle:ProductItem?=null,
    val articleList:List<ProductItem> ?= listOf(),
    val firstPageActive:Boolean=true,

    val showAddRecordDialog:Boolean=false,
    val newRecordName:String="",
    val isAddNewRecordSubmitClickable:Boolean=false,
    val addRecordErrorMessage:String="",


    val checkOutExpandAll:Boolean=false,
    val cashList: List<Children> ?= null,
    val checkOutSearchValue:String="",
    val priceLevels:List<String?> ?=null,
    val selectedPriceLevelIndex:Int?=null,

    val calendarData: YearModel = getYearsData(
        startYear = Constants.startYear,
        endYear = Constants.endYear
    ),
    val showCalendarDialog:Boolean=false,
    val selectedDate: MonthModel = MonthModel(),
    val selectedPalletColor:String ?= null,
    val showColorPalletDialog:Boolean=false,

    val selectedDays:Int=0,
    val showGenerateAIImgDialog:Boolean=false,
    val imageAiGeneratorDescription: String="",
    val imageAiGeneratorUrl:String?=null,
    val submitGeneratedImgLoading:Boolean=false,
    val isImageAiGeneratorLoading:Boolean=false,

    val catBasedProductList:List<Item?> ?=null,
    val showArticleListDialog:Boolean=false,
    val addNewProductToArticleErrMsg:String="",
    val showTemplateItemsFilterComponentDialog:Boolean=false,
    val selectedTemplateFilterItemsType: GridItemsFilterEnum = GridItemsFilterEnum.ACTIVE_ITEMS,

    val selectedWaiterDeviceType:WaiterDeviceTypeEnum=WaiterDeviceTypeEnum.MOBILE_WAITER,
    val selectedWaiterLayoutType: ListingLayoutsEnum=ListingLayoutsEnum.LIST,
    val currencyType:CurrencyTypeEnum=CurrencyTypeEnum.CHF,
    val selectedArticleSortId:String="",



)
